import React from 'react';
import Isvg from 'react-inlinesvg';
import { Link } from 'react-router-dom';

import { PFE_ICONS } from 'constants/icons';
import LINKS from 'constants/links';
import { intlMessage } from 'constants/propTypes';
import Message from 'components/Message';

import { actionResultPageMessages as messages } from './Auth.messages';

const ActionResultPage = ({ message }) => (
  <div className="auth__wrapper auth__wrapper--wide">
    <Isvg className="auth__logo" src={PFE_ICONS.logotype} />
    <Message
      as="h1"
      className="auth__header"
      message={message}
      values={{
        a: text => (
          <a href={LINKS.contact.partnerSuccessHref} target="_blank" rel="noopener noreferrer">
            {text}
          </a>
        ),
      }}
    />
    <div className="auth__quick-link-container mt-0">
      <Message as={Link} to="/login" className="auth__quick-link" message={messages.back} />
    </div>
  </div>
);

ActionResultPage.propTypes = {
  message: intlMessage,
};

export default ActionResultPage;
